<template>
  <div>
    <template v-if="!showPasswordPolicy">
      <v-text-field
        :append-icon="showPw ? 'mdi-eye' : 'mdi-eye-off'"
        :autocomplete="update ? 'new-password' : 'current-password'"
        :background-color="backgroundColor"
        :disabled="disabled"
        :error-count="showPasswordPolicy && !errorMessages ? 0 : 1"
        :error-messages="errorMessages"
        :label="placeholder ? null : label"
        :rules="rules"
        :type="showPw ? 'text' : 'password'"
        @click:append="showPw = !showPw"
        class="pwd-input"
        outlined
        :placeholder="placeholder"
        v-model="password"
      />
    </template>

    <template v-else>
      <v-tooltip bottom v-model="showTooltip">
        <template #activator="{ on }">
          <v-text-field
            :append-icon="showPw ? 'mdi-eye' : 'mdi-eye-off'"
            :autocomplete="update ? 'new-password' : 'current-password'"
            :background-color="backgroundColor"
            :disabled="disabled"
            :error-count="showPasswordPolicy && !errorMessages ? 0 : 1"
            :label="placeholder ? null : label"
            :passwordCheckEnabled="passwordCheckEnabled"
            :rules="rules"
            :type="showPw ? 'text' : 'password'"
            @blur="showTooltip=false"
            @click:append="showPw = !showPw"
            @focus="showTooltip=true"
            class="pwd-input"
            hide-details
            outlined
            v-model="password"
            :validate-on-blur="validateOnBlur"
            :placeholder="placeholder"
            v-on="on"
          />
          <fin-error-msg :msg="errorMessages"/>
        </template>

        <ul class="ml-0 pl-0" v-if="showPasswordPolicy && passwordCheckEnabled">
          <li :key="index" v-for="(value, index) in passwordPolicy">
            <template v-if="value.showRule">
              <v-icon :color="pwCheckIcons[index] ? $finColors.accentGreen : '#fff'" :size="16" class="mr-2">
                {{ pwCheckIcons[index] ? 'icon-check' : 'icon-close' }}
              </v-icon>
              <span v-html="value.descDE"/>
            </template>
            <template v-else>
              <v-icon :color="$finColors.accentRed" :size="16" class="mr-2" v-if="!pwCheckIcons[index]">
                icon-hint
              </v-icon>
              <span v-html="value.errorMsgDE" v-if="!pwCheckIcons[index]"/>
            </template>
          </li>
        </ul>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
import FinErrorMsg from '@/components/common/ErrorMsg'

export default {
  name: 'fin-password-input',
  components: {FinErrorMsg},
  props: {
    /** the entered password */
    value: {
      type: String
    },
    /** if set to true it disables the browsers autocomplete functionality */
    update: {
      type: Boolean
    },
    /** sets the label */
    label: {
      type: String,
      default: 'Passwort eingeben'
    },
    /** disables the input */
    disabled: {
      type: Boolean
    },
    /** sets a different background color */
    backgroundColor: {
      type: String,
      default: ''
    },
    /** sets an error message to display beneath the input */
    errorMessages: {
      type: String
    },
    /** the policy to check the entered password against */
    passwordPolicy: {
      type: Array,
      default() {
        return []
      }
    },
    /** should the password policy been displayed */
    showPasswordPolicy: {
      type: Boolean,
      default: false
    },
    /** should the password been checked */
    passwordCheckEnabled: {
      type: Boolean,
      default: true
    },
    /** live validation or validate on blur event */
    validateOnBlur: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    }
  },
  data() {
    return {
      password: this.value,
      showPw: false,
      showTooltip: false
    }
  },
  computed: {
    rules() {
      return this.passwordCheckEnabled ? this.passwordPolicy.map(entry => {
        return v => entry.check ? entry.check(v) || entry.descDE : true
      }) : []
    },
    pwCheckIcons() {
      return this.passwordPolicy.map(entry => entry.check?.(this.password) || false)
    }
  },
  watch: {
    value(val) {
      this.password = val
    },
    password(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>
.pwd-input ::v-deep .v-messages {
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 19px;
  letter-spacing: normal;
  color: #db2721;
}

.pwd-input ::v-deep .v-messages__message {
  padding-left: 20px;
  line-height: 19px;
}

.pwd-input ::v-deep .error--text .v-messages__message {
  background-image: url("./../../../../assets/error/warning.png");
}

.pwd-input ::v-deep .success--text .v-messages__message {
  background-image: url("./../../../../assets/error/success.png");
}

ul {
  list-style-type: none;
}

.v-tooltip__content {
  border-radius: unset;
  opacity: 1 !important;
  background: rgba(97, 97, 97, 1) !important;
}
</style>
